import { ChangeEvent, FC, InputHTMLAttributes } from 'react';
import styles from './PunchupSearch.module.css';

export interface PunchupSearchProps extends InputHTMLAttributes<HTMLInputElement> {
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	placeholder?: string;
	width?: string | number;
	fontSize?: string;
	className?: string;
	dataCy?: string;
	/** When provided, a × button appears inside the field whenever the input has a value. */
	onClear?: () => void;
}

const PunchupSearch: FC<PunchupSearchProps> = ({
	onChange,
	placeholder,
	width,
	fontSize,
	className,
	onClear,
	...rest
}: PunchupSearchProps) => (
	<div
		className={`${styles.container}${className ? ` ${className}` : ''}`}
		style={width ? { maxWidth: typeof width === 'number' ? `${width}px` : width } : undefined}
	>
		<svg
			className={styles.icon}
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<circle cx="11" cy="11" r="8" />
			<line x1="21" y1="21" x2="16.65" y2="16.65" />
		</svg>
		<input
			type="text"
			placeholder={placeholder}
			onChange={onChange}
			className={styles.input}
			style={fontSize ? { fontSize } : undefined}
			{...rest}
		/>
		{onClear && rest.value && (
			<button type="button" className={styles.clearButton} onClick={onClear} aria-label="Clear search">
				<svg
					width="12"
					height="12"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2.5"
					aria-hidden="true"
				>
					<path d="M18 6L6 18M6 6l12 12" />
				</svg>
			</button>
		)}
	</div>
);

export { PunchupSearch };
